import { render, staticRenderFns } from "./DictCheckbox.vue?vue&type=template&id=1afe8792&scoped=true"
import script from "./DictCheckbox.vue?vue&type=script&lang=js"
export * from "./DictCheckbox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1afe8792",
  null
  
)

export default component.exports